import { getDefaultProductPhoto } from '@jane/bloom/utils/product/getDefaultProductPhoto';
import type { ProductViewModel } from '@jane/bloom/viewModels/productDetail';

/**
 * @see https://developers.google.com/search/docs/appearance/structured-data/product-snippet
 */
export const buildProductMetadataViewModel = (product: ProductViewModel) => {
  const flavors = product.flavors ?? [];
  return {
    additional: {
      effectsList:
        product.feelings?.length > 0
          ? Array.from(new Set(product.feelings)).join(', ')
          : null,
      flavorsList: flavors.length > 0 ? flavors.join(', ') : null,
      lineage: product.category,
    },
    brand: product.brand,
    category: product.root_subtype,
    description: product.description,
    image: getDefaultProductPhoto({
      category: product.category,
      kind: product.kind,
      productRootSubtype: product.root_subtype,
      productType: product.type,
    }),
    name: product.name,
  };
};
